<div class="grade-icones">
    <mat-grid-list class="qwert" cols="3" rowHeight="49%" id="mat-grid-list">
        <mat-grid-tile>
            <button mat-button class="botao-icone" (click)="goToHome()">
                <img class="icone_grade" src="../../assets/home.png" alt="logo_inicio">
                <p class="p-icone">Início</p>
            </button>
        </mat-grid-tile>
        <mat-grid-tile>
            <button mat-button class="botao-icone" (click)="goToMeusDados()">
                <img class="icone_grade" src="../../../assets/person.png" alt="logo_meus-dados">
                <p class="p-icone">Meus Dados</p>
            </button>
        </mat-grid-tile>
        <mat-grid-tile>
            <a href="https://homolog.portaldoalunocurso.com.br/afiliado/loja" target="_blank">
                <button mat-button class="botao-icone">
                    <img class="icone_grade" src="../../../assets/store.png" alt="logo_minha-loja">
                    <p class="p-icone">Minha Loja</p>
                </button>
            </a>
        </mat-grid-tile>
        <mat-grid-tile class="grid4"> <!-- class="grid4" classe usada para quando era 5 icones -->
            <button mat-button class="botao-icone" (click)="goToDinheiroBolso()">
                <img class="icone_grade" src="../../../assets/dinheiro.png" alt="logo_dinheiro-bolso">
                <p class="p-icone">Dinheiro no Bolso</p>
            </button>
        </mat-grid-tile>
        <mat-grid-tile class="grid5"> <!-- class="grid5" classe usada para quando era 5 icones -->
            <!-- <button mat-button class="botao-icone">
                <img class="icone_grade" src="../../../assets/simulados2.png" alt="logo_conteudo_digital">
                <p class="p-icone">Conteúdo</p>
            </button> -->
        </mat-grid-tile>
        <mat-grid-tile class="grid6"> <!--  *ngIf="cursoEjaEnccejaEAD != 'EAD'" -->
            <a href="https://t.me/supletivopreparatorioejaencceja" target="_blank">
                <button mat-button class="botao-icone">
                    <img class="icone_grade" src="../../../assets/telegram2.png" alt="logo_telegram">
                    <p class="p-icone">Telegram</p>
                </button>
            </a>
        </mat-grid-tile>
        <!-- <mat-grid-tile *ngIf="cursoEjaEnccejaEAD == 'EAD'">
            <a href="https://t.me/cursosnacionaltec" target="_blank">
                <button mat-button class="botao-icone">
                    <img class="icone_grade" src="../../../assets/telegram2.png" alt="logo_telegram">
                    <p class="p-icone">Telegram</p>
                </button>
            </a>
        </mat-grid-tile> -->
    </mat-grid-list>
</div>